import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propStr, propFunc, propOneOf, propChildren, } from '../../../../helpers/custom-prop-types';
import RegistrationLink from '../../../Ui/Registration/RegistrationLink';
const ProfessionalUnitItemsListMoreButton = (props) => {
    const { children, className, onClick, userMode } = props;
    const isGuest = userMode === 'guest';
    return (_jsx(RegistrationLink, { className: clsx(isGuest ? 'primary is-guest' : 'service', className), isNoLinkComponent: isGuest ? undefined : 'button', onClick: isGuest ? undefined : onClick, text: children }));
};
ProfessionalUnitItemsListMoreButton.propTypes = {
    children: propChildren().isRequired,
    className: propStr(),
    onClick: propFunc(),
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
ProfessionalUnitItemsListMoreButton.defaultProps = {
    className: '',
    onClick: undefined,
};
export default ProfessionalUnitItemsListMoreButton;
